var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',[_vm._v("\n### 请点击左侧菜单选择内容\n")])}
var staticRenderFns = []

export { render, staticRenderFns }